// Which country the device is in, ported from the design's senderRegion(). It
// decides which stamps a sender can buy: stamps are sold where you are, so a
// friend travelling in Bogotá posts with Colombian stamps.

const REGION: Record<string, string> = {
  EC: 'ecuador', CO: 'colombia', PE: 'perú', MX: 'méxico', AR: 'argentina', CL: 'chile',
  ES: 'españa', US: 'estados unidos', CA: 'canadá', GB: 'reino unido', DE: 'alemania',
  FR: 'francia', IT: 'italia', PT: 'portugal', BR: 'brasil', NL: 'países bajos',
};

const TZ_REGION: Record<string, string> = {
  'America/Guayaquil': 'EC', 'Pacific/Galapagos': 'EC', 'America/Bogota': 'CO',
  'America/Lima': 'PE', 'America/Mexico_City': 'MX', 'America/Argentina/Buenos_Aires': 'AR',
  'America/Santiago': 'CL', 'Europe/Madrid': 'ES', 'Europe/London': 'GB',
  'Europe/Berlin': 'DE', 'Europe/Paris': 'FR', 'Europe/Rome': 'IT', 'Europe/Lisbon': 'PT',
  'America/Sao_Paulo': 'BR', 'Europe/Amsterdam': 'NL', 'America/New_York': 'US',
  'America/Chicago': 'US', 'America/Denver': 'US', 'America/Los_Angeles': 'US',
  'America/Toronto': 'CA', 'America/Vancouver': 'CA',
};

export function deviceCountry(): string {
  try {
    const fromZone = TZ_REGION[Intl.DateTimeFormat().resolvedOptions().timeZone];
    if (fromZone && REGION[fromZone]) return REGION[fromZone];

    const langs = (navigator.languages?.length ? navigator.languages : [navigator.language ?? '']).join(',');
    const code = langs.match(/-([A-Z]{2})\b/)?.[1];
    if (code && REGION[code]) return REGION[code];
  } catch {
    // Fall through to the home country.
  }
  return 'ecuador';
}
